import { ScriptsView } from '@/modules/scripts/components/ScriptView'

export const ScriptPage = () => {
  return <ScriptsView />
}
